import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Typography,
  Chip,
  Link,
  Stack,
} from "@mui/material";

// snake_case → Title Case
const formatLabel = (key) =>
  key
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

const UpdateDetailsModal = ({
  setShowDetailsModal,
  showDetailsModal,
  selectedUpdateData = {},
}) => {
  let data;
  try {
    data =
      typeof selectedUpdateData === "string"
        ? JSON.parse(selectedUpdateData)
        : selectedUpdateData;
  } catch {
    data = {};
    console.error(
      "Failed to parse selectedUpdateData as JSON:",
      selectedUpdateData
    );
  }
  return (
    <Dialog
      open={showDetailsModal}
      onClose={() => setShowDetailsModal(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Update Details</DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            backgroundColor: "#fafafa",
            borderRadius: 2,
          }}
        >
          <Grid container spacing={3}>
            {Object.entries(data).map(([key, value]) => (
              <Grid item xs={12} sm={6} key={key}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {formatLabel(key)}
                </Typography>

                {Array.isArray(value) ? (
                  <Stack direction="row" flexWrap="wrap" gap={1}>
                    {value.map((item, idx) => (
                      <Chip key={idx} label={String(item)} size="small" />
                    ))}
                  </Stack>
                ) : key.toLowerCase().includes("url") ? (
                  <Link
                    href={
                      String(value).startsWith("http")
                        ? value
                        : `https://${value}`
                    }
                    target="_blank"
                    rel="noopener"
                    underline="hover"
                    sx={{ wordBreak: "break-all" }}
                  >
                    {value}
                  </Link>
                ) : (
                  <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                    {String(value) || <i>(empty)</i>}
                  </Typography>
                )}
              </Grid>
            ))}
          </Grid>
        </Paper>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setShowDetailsModal(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateDetailsModal;
